export const centimetersToMeters = (target: number): number | undefined => {
    if (target === null || target === undefined) {
        return undefined;
    }
    return (target * 100) / 10000;
};
